import { Timer as AntdTimer } from "@empglabs/backoffice-ui-kit"

const Timer = props => {
  return <AntdTimer {...props} />
}

export default Timer
